import React from "react";
import { PrimeReactProvider, addLocale, locale } from "primereact/api";
import { twMerge } from "tailwind-merge";
import { usePassThrough } from "primereact/passthrough";
import Tailwind from "primereact/passthrough/tailwind";

import "./autocomplete.css";
import "./badge.css";
import "./checkbox.css";
import "./datatable.css";
import "./floatlabel.css";
import "./iconfield.css";
import "./inputswitch.css";
import "./radiobutton.css";
import "./prime.css";
import "./tabview.css";

import { autocomplete } from "./passthrough/autocomplete";
import { button } from "./passthrough/button";
import { chip } from "./passthrough/chip";
// import { checkbox } from "./passthrough/checkbox";
import { datatable } from "./passthrough/datatable";
import { dialog } from "./passthrough/dialog";
import { dropdown } from "./passthrough/dropdown";
import { inputtext } from "./passthrough/inputtext";
// import { inputswitch } from "./passthrough/inputswitch";
import { tooltip } from "./passthrough/tooltip";
import { inputtextarea } from "./passthrough/inputtextarea";
import { message } from "./passthrough/message";
import { selectbutton } from "./passthrough/selectbutton";
import { calendar } from "./passthrough/calendar";
import LANG from "./locale/es.json";
import { progressbar } from "./passthrough/progressbar";
import { multiselect } from "./passthrough/multiselect";
import { inputnumber } from "./passthrough/inputnumber";
import { treetable } from "./passthrough/treetable";
import { splitbutton } from "./passthrough/splitbutton";
import { menubar } from "./passthrough/menubar";

export default function PrimeProvider({ children }: { readonly children: React.ReactNode }) {
  LANG.es.firstDayOfWeek = 0;
  LANG.es.dayNamesMin = ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sá"];
  addLocale("es", LANG.es);
  locale("es");

  const NamekTailwind = usePassThrough(
    {
      autocomplete,
      button,
      chip,
      // checkbox, // using a css waiting fix pt bug: https://github.com/primefaces/primereact/issues/6291
      dialog,
      datatable,
      dropdown,
      // inputswitch, // works better the css way
      inputtext,
      inputnumber,
      inputtextarea,
      messages: Tailwind.messages,
      message,
      menubar,
      calendar,
      progressbar,
      multiselect,
      selectbutton,
      splitbutton,
      tooltip,
      treetable,
    },
    { mergeSections: true, mergeProps: false, classNameMergeFunction: twMerge },
  );

  return (
    <PrimeReactProvider
      value={{
        zIndex: {
          modal: 1500, // dialog, sidebar
          overlay: 1400, // dropdown, overlaypanel upper than MUI modals
          menu: 1350, // overlay menus
          tooltip: 1500, // tooltip
          toast: 1600, // toast
        },
        unstyled: false,
        pt: NamekTailwind,
        ptOptions: { mergeSections: true, mergeProps: true, classNameMergeFunction: twMerge },
        hideOverlaysOnDocumentScrolling: true,
      }}
    >
      {children}
    </PrimeReactProvider>
  );
}
